// Client V1 imports
const { track } = require('client/lib/analytics')
const airbrake = require('client/lib/airbrake')

// Common Client V2 imports
const { navigate } = require('client-v2/common/state/router/actions')

// Action dispatchers

function navigateToArticleSearch(text) {
  return function (dispatch) {
    track('search-topic', {
      text,
      metabase: {
        'actioned_object_type': 'topic',
        'actioned_object_id': text
      }
    })
    .then(() => {
      dispatch(navigate(searchArticlesHref(text)))
    })
    .catch(err => airbrake.notify(err))
  }
}

// Helpers

function searchArticlesHref(query) {
  return `/search/${encodeURIComponent(query)}`
}

module.exports = {
  navigateToArticleSearch
}
